import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { Controller, useForm } from 'react-hook-form';
import { DropdownList } from 'react-widgets';

import 'react-widgets/dist/css/react-widgets.css';
import moment from 'moment';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../../../api';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { Lead, Influencer, AgeLimit, Customer } from '../../../../core';

const MarkInfluence: React.FunctionComponent<{
  error?: string;
  onSuccess: (lead: Lead) => void;
  user?: Customer;
  onClose: () => void;
  leadId?: string;
}> = (props) => {
  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

  const { data: influencers } = useDataLoader<Influencer[]>(() =>
    api.influencer.loadAllInfluencer()
  );

  const {
    control,
    handleSubmit,
    errors,
    clearErrors,
    watch,
    setValue,
  } = useForm<Customer>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  React.useEffect(() => {
    if (watch('dob')) {
      const year = moment().diff(watch('dob'), 'years', true);
      const ageRange = AgeLimit?.find((a) => a.from <= year && a.to >= year);
      setValue('ageRange', ageRange?.name);
    }
  }, [watch('dob')]);

  const onSubmit = async (data?: any) => {
    setIsSubmiting(true);

    const updateData = {
      influenceId: data.influencerId,
      userId: props.user?._id!,
    };

    try {
      await api.lead.updateUserInfluence(updateData, props.leadId!);

      const response = await api.lead.getLead(props.leadId!);

      props.onSuccess(response?.data);
      toastr.success('Success', 'Influencer marked successfully');
    } catch (error) {
      if (error?.response?.data?.message) {
        toastr.error('Error', error?.response?.data?.message);
      }
    }
    setIsSubmiting(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="p-4">
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Mark Influence Of {props.user?.name}<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            name="influencerId"
            rules={{ required: true }}
            defaultValue={props.user?.influencer?._id}
            render={({ onChange, value, name }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                data={influencers?.map((key) => {
                  return {
                    _id: key._id,
                    name: key.name,
                  };
                })}
                textField={'name'}
                valueField={'_id'}
                placeholder={'Select Influencer'}
                onChange={(val) => {
                  onChange(val._id);
                }}
              />
            )}
          />
          {errors.influencerId && (
            <ErrorMessage>Influencer is required</ErrorMessage>
          )}
        </div>

        <div className="form-group pt-2 text-right">
          <button
            onClick={() => {
              props.onClose();
            }}
            type="button"
            className="btn btn-outline-primary px-lg-3 px-2 mb-sm-0 mb-1 font-weight-bold font-normal py-2"
          >
            Cancel
          </button>
          <button
            disabled={isSubmiting}
            className="btn btn-primary font-normal font-weight-bold m-auto mb-1 mb-sm-0 ml-3 px-2 px-lg-3 py-2"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  );
};

export default MarkInfluence;
